function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import convertOnsiteMessageData from '../components/internal/convertOnsiteMessageData';
import { EMPTY_ONSITE_MESSAGE_WRAPPER } from '../components/internal/constants';
var MOBILE_SCREEN_SIZE = 480;
export var getOMPDisplayStatus = function getOMPDisplayStatus(_ref) {
  var _messageRenderingDeta;

  var messageData = _ref.messageData,
      placementName = _ref.placementName;

  if (!messageData) {
    return {
      showEmptyOMP: false,
      showFullOMP: false
    };
  }

  var messageRenderingDetails = convertOnsiteMessageData(messageData, placementName, {});
  var eventData = messageRenderingDetails === null || messageRenderingDetails === void 0 ? void 0 : (_messageRenderingDeta = messageRenderingDetails.renderingProps) === null || _messageRenderingDeta === void 0 ? void 0 : _messageRenderingDeta.eventData;
  return {
    showEmptyOMP: eventData && !(eventData === null || eventData === void 0 ? void 0 : eventData.shouldDisplay) || (messageRenderingDetails === null || messageRenderingDetails === void 0 ? void 0 : messageRenderingDetails.componentName) === EMPTY_ONSITE_MESSAGE_WRAPPER,
    showFullOMP: (messageRenderingDetails === null || messageRenderingDetails === void 0 ? void 0 : messageRenderingDetails.componentName) !== EMPTY_ONSITE_MESSAGE_WRAPPER && (eventData === null || eventData === void 0 ? void 0 : eventData.shouldDisplay)
  };
}; // only when it is in app

export var getNativeQuestionnaireAPI = function getNativeQuestionnaireAPI() {
  if (typeof window !== 'undefined' && _typeof(window.ZMOB_nativeAPI) === 'object' && typeof window.ZMOB_nativeAPI.startSellToZillow === 'function') {
    return window.ZMOB_nativeAPI.startSellToZillow;
  }

  return undefined;
};
export var getMobile = function getMobile() {
  var _window;

  return ((_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) <= MOBILE_SCREEN_SIZE;
};